export default __webpack_public_path__ + "static/media/labs-uni-icon.80fb3e58.svg";